"use client";

import React from "react";
import { Check, User, Sparkles } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * WebsiteForTradespeople — Section 6: Pricing 2 Pakete
 * Drop-in für: src/pages/WebsiteForTradespeople/sections/ChooseYourPathToHarmony.tsx
 */

const plans = [{
  name: "Starter",
  typeLabel: "Selber machen (DIY)",
  typeIcon: User,
  description: "Sie erstellen Ihre Handwerker-Website selbst — mit dem KI-Builder in wenigen Minuten.",
  price: "CHF 24",
  period: "/ Monat",
  features: ["Komplette Handwerker-Website", "Hosting + Domain + SSL inklusive", "Google-Optimierung (SEO)", "Jederzeit selbst bearbeiten", "Keine Kreditkarte für Test nötig"],
  cta: "3 Tage gratis testen",
  href: "https://dashboard.pagemaker24.ch/checkout?product_id=255&period=monthly",
  featured: false
}, {
  name: "Pro Website",
  typeLabel: "Experte erstellt Ihre Website",
  typeIcon: Sparkles,
  description: "Unser Team erstellt Ihre komplette Website inklusive Referenz-Aufbereitung — Sie lehnen sich zurück.",
  price: "CHF 72",
  period: "/ Monat",
  features: ["Alles aus Starter", "Professionelle Erstellung durch Experten", "Referenz-Fotos professionell aufbereitet", "5 Änderungen pro Jahr inklusive", "Persönlicher Ansprechpartner"],
  cta: "Jetzt starten",
  href: "https://dashboard.pagemaker24.ch/checkout?product_id=517&period=yearly",
  featured: true
}];
export default function ChooseYourPathToHarmony() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section className="bg-background py-20 md:py-24">
      <div ref={ref} className={`max-w-4xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-3xl mx-auto mb-14 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-4 leading-tight">
            Günstiger als ein Stundenlohn
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            Ihre professionelle Handwerker-Website ab CHF 24/Monat.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
          {plans.map(plan => {
          const TypeIcon = plan.typeIcon;
          return <div key={plan.name} className={`relative rounded-xl p-8 ${plan.featured ? "border-2 border-primary shadow-lg shadow-primary/10 bg-background" : "border border-border bg-background"}`}>
                {plan.featured && <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary/10 text-primary text-xs font-medium px-3 py-1 rounded-md border border-primary/20">
                    Empfohlen
                  </span>}

                <div className="inline-flex items-center gap-1.5 bg-green-50 text-green-700 text-xs font-medium px-2.5 py-1 rounded-full mb-4 border border-green-200">
                  <Check className="w-3 h-3" strokeWidth={2.5} />
                  3 Tage gratis testen
                </div>

                <h3 className="text-lg font-semibold text-foreground mb-2">
                  {plan.name}
                </h3>

                <div className={`inline-flex items-center gap-2 text-xs font-medium px-3 py-1.5 rounded-full mb-3 ${plan.featured ? "bg-primary/10 text-primary" : "bg-secondary text-muted-foreground"}`}>
                  <TypeIcon className="w-3.5 h-3.5" strokeWidth={1.5} />
                  {plan.typeLabel}
                </div>

                <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
                  {plan.description}
                </p>

                <div className="flex items-baseline gap-1 mb-6">
                  <span className="text-3xl font-bold text-foreground">
                    {plan.price}
                  </span>
                  <span className="text-muted-foreground">{plan.period}</span>
                </div>

                <ul className="space-y-3 mb-8 text-sm text-muted-foreground">
                  {plan.features.map((f, i) => <li key={i} className="flex items-start gap-2">
                      <Check className="w-4 h-4 text-green-500 mt-0.5 shrink-0" strokeWidth={2.5} />
                      {f}
                    </li>)}
                </ul>

                <a href={plan.href} className={`block text-center py-3.5 text-sm font-medium rounded-lg transition-all ${plan.featured ? "bg-primary text-white hover:opacity-90 shadow-lg shadow-primary/20" : "border border-border text-foreground hover:bg-secondary"}`}>
                  {plan.cta}
                </a>
              </div>;
        })}
        </div>

        <p className="text-center text-sm text-muted-foreground mt-8">
          Beide Pakete starten mit 3 Tagen gratis — keine Kreditkarte nötig.
        </p>
      </div>
    </section>;
}